import Axios from "axios";
import _ from "underscore";
import qs from "qs";
import config from "@/config";
import apis from "@/apis";
import store from "@/store";
import router from "@/router";
import localStorage from "@/libs/localStorage";
import ElementUI from "element-ui";

const BASEURL = config.baseURL;
const TIMEOUT = config.timeout;

// status code
const STATUS_CODE = {
  succsess: 0,
  token: 401
};
// const LOADINGCFG = {
//   lock: true,
//   text: 'LOADING',
//   spinner: 'el-icon-loading',
//   background: 'rgba(0, 0, 0, 0.7)'
// }
// let Loading = ''

/* Axios */
// baseURL
// Axios.defaults.baseURL = BASEURL;
Axios.defaults.timeout = TIMEOUT;
// Header
// let headers = {
//   Authorization: 'BasicAuth',
//   token: store.getters.getToken || ''
// }

// Axios.defaults.headers.common['Authorization'] = 'BasicAuth'

Axios.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
);

Axios.interceptors.response.use(
  response => response,
  error => Promise.resolve(error.response)
);

/**
 * 检查Request请求状态
 * @param {Object} response
 * @return {*}
 */
function checkStatus(response = {}) {
  // console.log(response)
  if (response.status === 200 || response.status === 304) {
    return response.data;
  } else {
    let message = response.statusText;
    // switch (response.status) {
    //   case 400:
    //     message = "请求错误";
    //     break;
    //   case 401:
    //     message = "未授权，请登录";
    //     break;
    //   case 403:
    //     message = "拒绝访问";
    //     break;
    //   case 404:
    //     message = `请求地址出错：${response.config.url}`;
    //     break;
    //   case 408:
    //     message = "请求超时";
    //     break;
    //   case 500:
    //     message = "服务器内部错误";
    //     break;
    //   case 501:
    //     message = "服务未实现";
    //     break;
    //   case 502:
    //     message = "网关错误";
    //     break;
    //   case 503:
    //     message = "服务不可用";
    //     break;
    //   case 504:
    //     message = "网关超时";
    //     break;
    //   case 505:
    //     message = "HTTP版本不受支持";
    //     break;
    // }
    return {
      code: response.status,
      message: message,
      data: response.statusText
    };
  }
}

/**
 * 检查Response返回结果
 * @param {Object} result result
 * @return {*}
 */
function checkResult(result) {
  // 加载动画
  // Loading.close()
  // 状态码过滤
  if (result.code === STATUS_CODE.succsess) {
    // 成功
  } else {
    // 失败
    if (result.code === STATUS_CODE.token) {
      // token失效
      ElementUI.Message.error("登录失效，请重新登录");
      router.push({ name: "login" });
      localStorage.clear();
      store.commit("clearLocalStorage");
    }
  }
  // if (result.code && result.code !== STATUS_CODE.token) {
  //   let msg = result.message || '意外的处理结果'
  //   // token过期
  //   if (result.code === STATUS_CODE.token) {
  //     msg = '登录失效，请重新登录'
  //     ElementUI.Message.error(msg)
  //     router.push({name: 'login'})
  //     localStorage.clear()
  //     store.commit('clearLocalStorage')
  //   } else {
  //     // let msg = result.message || '意外的处理结果'
  //     ElementUI.Message.error(msg)
  //   }
  // } else {
  //   router.push({name: 'login'})
  // }
  return result;
}

let request = {};

_.map(apis, (val, key) => {
  _.map(val, v => {
    let { name, url, method } = v;
    request[`${key}_${name}`] = (data, initOps = {}) => {
      // start loading
      // Loading = ElementUI.Loading.service(LOADINGCFG)

      // headers
      let headers =
        initOps.headers && typeof initOps.headers === "object"
          ? initOps.headers
          : {
              "content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
              // token: store.getters.getToken || ""
              token: localStorage.get("token") || ""
            };

      // data
      let transData = "";
      if (method === "get") {
        transData = data;
      } else if (method === "post") {
        transData =
          initOps.data && initOps["data"]["type"] === "default"
            ? data
            : qs.stringify(data);
      }

      // request options
      let options = {
        method,
        url,
        timeout: TIMEOUT,
        headers
      };

      // handle get or post params
      options[method === "get" ? "params" : "data"] = transData;

      return Axios(options)
        .then(checkStatus)
        .then(checkResult)
        .catch(e => e);
    };
  });
});

// 遍历拼装

// let {name, url, method} = apis.user.login
//
// let login = data => {
//   return Axios({
//     method,
//     url,
//     data,
//     timeout: 10000,
//     headers
//   })
//     .then(checkStatus)
//     .then(checkResult)
// }
//
// request._login = login

export default request;
